/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBedFlat = createReactComponent("bed-flat", "IconBedFlat", [
  ["path", { d: "M5 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-0" }],
  ["path", { d: "M10 13h11v-2a3 3 0 0 0 -3 -3h-8v5z", key: "svg-1" }],
  ["path", { d: "M3 16h18", key: "svg-2" }]
]);

export { IconBedFlat as default };
//# sourceMappingURL=IconBedFlat.js.map
